module.exports = __webpack_public_path__ + "static/tuples.9ecbfb50.webp";


//////////////////
// WEBPACK FOOTER
// ./src/images/portfolio/tuples.webp
// module id = 446
// module chunks = 23899280101116